define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var ServerPasswordModel = /** @class */ (function () {
        function ServerPasswordModel(data) {
            this.Password = ko.observable();
            this.ServerId = ko.observable();
            this.ServerPassword = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, ServerPasswordModel.Mapping, self);
            }
        }
        ServerPasswordModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new ServerPasswordModel(options.data);
            }
        };
        return ServerPasswordModel;
    }());
    return ServerPasswordModel;
});
//# sourceMappingURL=ServerPasswordModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/ServerPasswordModel.js
// module id = 90
// module chunks = 2